/**
 * The account filter on a parent — `docs/bugs.md` session 6, "Companies with
 * multiple locations" in the decisions file.
 *
 * **One filter vocabulary.** `accountId` means the account AND every live
 * account under it, at any depth, in the opportunity list
 * (`opportunityFilterSchema`), every analytics endpoint and the analytics CSV
 * exports, the Funnel report included (`analyticsFilterSchema`).
 * `accountScope=exact` narrows it to the one account, for the callers that
 * mean exactly that: a meeting's deal picker, the dashboard's per-account
 * drill-through (whose row counts one account) and the account strategy
 * header. A soft-deleted account ends the chain below it.
 */

import { z } from 'zod';

export const accountScopeSchema = z.enum(['exact']);
export type AccountScope = z.infer<typeof accountScopeSchema>;

/** The wording, exactly, everywhere the account filter is explained. */
export const ACCOUNT_FILTER_HELP_TEXT =
  "Includes the account's sites — every account under it, at any depth.";

/** Shown instead when the filter is narrowed to the one account. */
export const ACCOUNT_FILTER_EXACT_TEXT = "This account only — its sites' deals are not included.";
